import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import Mainroutes from './main.routes';
import ToastProvider from './Components/Others/ToastProvider';
import "./i18n"
import { CurrencyProvider } from './Context/CurrencyContext';
import { SidebarProvider } from './Context/SidebarContext';
import { ToastContainer } from 'react-toastify';
import { SocketProvider } from './Context/SocketContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000,    // 10 minutes
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <SocketProvider>
      <ToastProvider>
        <ToastContainer position="top-right" autoClose={3000} stacked />
        <BrowserRouter>
          <CurrencyProvider>
            <SidebarProvider>
              <Mainroutes />
            </SidebarProvider>
          </CurrencyProvider>
        </BrowserRouter>
      </ToastProvider>
    </SocketProvider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
